import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_SIGN: MijnRoute = {
    path: ':id/signeren',
    navigationEvent: 'toBeleggenSigneren',
    regex: /^\/beleggen\/[^/]+\/signeren$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/signeren'
};
